export const RESET = "FEED_LIST_RESET";
export const SET_ITEMS = "FEED_LIST_SET_ITEMS";
export const SET_ERROR = "FEED_LIST_SET_ERROR";
export const SET_SELECT_ITEMS = "FEED_LIST_SET_SELECT_ITEMS";
export const SET_VIEW = "FEED_LIST_SET_VIEW";
export const TOGGLE_LOADING = "FEED_LIST_TOGGLE_LOADING";
// START:CUSTOM - generated
export const SET_TOTAL_ITEMS = "FEED_LIST_SET_TOTAL_ITEMS";
export const SET_ITEMS_PER_PAGE = "FEED_LIST_SET_ITEMS_PER_PAGE";
export const SET_PAGE_NO = "FEED_LIST_SET_PAGE_NO";
export const SET_SEARCH = "FEED_LIST_SET_SEARCH";
export const SET_FILTERS = "FEED_LIST_SET_FILTERS";
export const SET_ORDER_BY = "FEED_LIST_SET_ORDER_BY";
export const SET_ORDER_DIR = "FEED_LIST_SET_ORDER_DIR";
// END:CUSTOM - generated
